import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { buildCredentials } from './types';
var defaultRequestServiceOptions = {};
var buildUrl = function buildUrl(baseUrl) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var queryParams = arguments.length > 2 ? arguments[2] : undefined;
  var secOptions = arguments.length > 3 ? arguments[3] : undefined;
  var searchParam = new URLSearchParams(
  // For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
  // Since we only care about search params it is fine to have any base url here.
  new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
  baseUrl = baseUrl.split('?')[0];
  if (queryParams) {
    for (var key in queryParams) {
      if ({}.hasOwnProperty.call(queryParams, key)) {
        searchParam.append(key, queryParams[key]);
      }
    }
  }
  if (secOptions && secOptions.params) {
    for (var _key in secOptions.params) {
      if ({}.hasOwnProperty.call(secOptions.params, _key)) {
        var values = secOptions.params[_key];
        if (Array.isArray(values)) {
          for (var i = 0; i < values.length; i++) {
            searchParam.append(_key, values[i]);
          }
        } else {
          searchParam.append(_key, values);
        }
      }
    }
  }
  var separator = '';
  if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) {
    separator = '/';
  }
  var params = searchParam.toString();
  if (params) {
    params = '?' + params;
  }
  return "".concat(baseUrl).concat(separator).concat(path).concat(params);
};
var addToHeaders = function addToHeaders(headers, keyValues) {
  if (keyValues) {
    for (var key in keyValues) {
      if ({}.hasOwnProperty.call(keyValues, key)) {
        var values = keyValues[key];
        if (Array.isArray(values)) {
          for (var i = 0; i < values.length; i++) {
            headers[key] = values[i];
          }
        } else {
          headers[key] = values;
        }
      }
    }
  }
};
var buildHeaders = function buildHeaders(secOptions, extraHeaders) {
  var headers = {};
  addToHeaders(headers, extraHeaders);
  if (secOptions) {
    addToHeaders(headers, secOptions.headers);
  }
  return headers;
};

/**
 * @returns Promise containing the json response
 */
export var requestService = function requestService(serviceConfig, options) {
  var url = serviceConfig.url,
    securityProvider = serviceConfig.securityProvider,
    refreshedSecurityProvider = serviceConfig.refreshedSecurityProvider;
  var _ref = options || defaultRequestServiceOptions,
    path = _ref.path,
    queryParams = _ref.queryParams,
    requestInit = _ref.requestInit;
  var secOptions = securityProvider && securityProvider();
  var requestUrl = buildUrl(url, path, queryParams, secOptions);
  var headers = buildHeaders(secOptions, requestInit && requestInit.headers);
  var credentials = buildCredentials(secOptions);
  var ignoreResponsePayload = (options === null || options === void 0 ? void 0 : options.ignoreResponsePayload) || false;
  var requestOptions = _objectSpread(_objectSpread({}, requestInit), {}, {
    headers: headers,
    credentials: credentials
  });
  return fetch(requestUrl, requestOptions).then(function (response) {
    if (response.status === 204) {
      return Promise.resolve();
    } else if (response.ok) {
      return ignoreResponsePayload ? Promise.resolve() : response.json();
    } else if (response.status === 401 && refreshedSecurityProvider) {
      // auth issue - try once
      return refreshedSecurityProvider().then(function (newSecOptions) {
        var retryServiceConfig = {
          url: url,
          securityProvider: function securityProvider() {
            return newSecOptions;
          }
        };
        return requestService(retryServiceConfig, options);
      });
    }
    return Promise.reject({
      code: response.status,
      reason: response.statusText
    });
  });
};